import { render } from "./TheFavorites.vue?vue&type=template&id=72a848a2&scoped=true"
import script from "./TheFavorites.vue?vue&type=script&lang=js"
export * from "./TheFavorites.vue?vue&type=script&lang=js"

import "./TheFavorites.vue?vue&type=style&index=0&id=72a848a2&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a848a2"]])

export default __exports__